// Claude 2026-11-04. Owned analytics: what visitors do on the site and in the portal, saved to our own Supabase (bs-analytics).
// Read in Pack Station → Analytics. Runs after the page, sends small batches in the background, and can never break a page:
// every part is wrapped so a failure here is silent.
// Never collected: typed text, input values, names, emails, IP addresses, or URL query strings (links carry sign-in tokens).
// Skips: Shopify's consent "no", Global Privacy Control, the theme editor, automated browsers.
// Your own visits: open any page once with ?bs_an=off (undo with ?bs_an=on). Preview themes and ?demo=1 are marked as test data.
// Other files can report with window.bsTrack('add_to_cart', {qty: 1}); unknown names are dropped by the server.
(function () {
  'use strict';
  var script = document.currentScript;
  var ENDPOINT = script && script.dataset.endpoint;
  var queue = [], timer = null, allowed = null, stopped = false;
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { return; }
  var isOwnerFlag = params.get('bs_an');
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) { /* private mode */ } },
  };
  window.bsTrack = function () {};
  if (isOwnerFlag === 'off') store.set('bs_an_off', '1');
  if (isOwnerFlag === 'on') store.del('bs_an_off');
  if (!ENDPOINT || store.get('bs_an_off') || window.Shopify && window.Shopify.designMode || navigator.webdriver && isOwnerFlag !== 'debug') return;

  var debug = isOwnerFlag === 'debug';
  var test = !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main') || params.has('demo');

  // ---------- who (random IDs, nothing personal) ----------
  var uid = function () { return window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2); };
  var memory = null, isNew = false;
  function ids() {
    var now = Date.now(), raw = store.get('bs_an'), a = memory;
    try { if (raw) a = JSON.parse(raw); } catch (e) { /* start fresh */ }
    if (!a || !a.v) { a = { v: uid() }; isNew = true; }
    if (!a.s || now - (a.t || 0) > 30 * 60000) a.s = uid();
    a.t = now;
    memory = a;
    store.set('bs_an', JSON.stringify(a));
    return a;
  }
  function device() {
    var w = window.innerWidth || 0, coarse = window.matchMedia && matchMedia('(pointer:coarse)').matches;
    return w < 768 ? 'mobile' : coarse && w < 1200 ? 'tablet' : 'desktop';
  }

  // ---------- sending ----------
  function flush() {
    clearTimeout(timer); timer = null;
    if (!queue.length || allowed !== true || stopped) return;
    var a = ids(), now = Date.now();
    var batch = queue.splice(0, 40).map(function (e) { return { n: e.n, p: e.p, x: now - e.t, o: e.o }; });
    var body = JSON.stringify({ v: a.v, s: a.s, d: device(), env: test ? 'preview' : 'live', e: batch });
    if (debug) console.log('[bs-analytics]', batch);
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' })))) {
        fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) { /* analytics never breaks the page */ }
    if (queue.length) timer = setTimeout(flush, 500);
  }
  function track(name, props) {
    try {
      if (stopped) return;
      queue.push({ n: name, p: location.pathname, t: Date.now(), o: props || {} });
      if (queue.length > 200) queue.splice(0, queue.length - 200);
      if (!timer) timer = setTimeout(flush, 5000);
    } catch (e) { /* analytics never breaks the page */ }
  }
  window.bsTrack = track;

  // ---------- consent ----------
  function decide(ok) {
    allowed = ok;
    if (!ok) { stopped = true; queue.length = 0; window.bsTrack = function () {}; } else flush();
  }
  function checkConsent() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (p && p.analyticsProcessingAllowed) { decide(!!p.analyticsProcessingAllowed() && !navigator.globalPrivacyControl); return true; }
    return false;
  }
  function startConsent() {
    if (navigator.globalPrivacyControl) { decide(false); return; }
    if (checkConsent()) return;
    try {
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err || !checkConsent()) { if (allowed === null) decide(true); } });
      }
    } catch (e) { /* falls through to the timer */ }
    // No consent tool answered (no banner in this region): Shopify's default for the region is "allowed".
    setTimeout(function () { if (allowed === null) decide(true); }, 2000);
    document.addEventListener('visitorConsentCollected', function () { checkConsent(); });
  }

  // ---------- page view + how far they read ----------
  var shownAt = 0, engaged = 0, maxScroll = 0, lcp = 0, lcpSent = false;
  function pageView() {
    var o = { w: window.innerWidth };
    ids();
    if (isNew) { o.new = 1; isNew = false; }
    try { if (document.referrer) o.ref = new URL(document.referrer).hostname; } catch (e) { /* no referrer */ }
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { var v = params.get(k); if (v) o[k] = v; });
    if (params.has('fbclid')) o.fbclid = 1;
    if (params.has('gclid')) o.gclid = 1;
    track('page_view', o);
    if (/\/search/.test(location.pathname) && params.get('q')) track('search', { q: params.get('q') });
    shownAt = document.visibilityState === 'visible' ? Date.now() : 0;
    engaged = 0;
    measureScroll();
  }
  function measureScroll() {
    var doc = document.documentElement, h = Math.max(doc.scrollHeight, 1);
    maxScroll = Math.max(maxScroll, Math.min(100, Math.round(((window.scrollY || 0) + window.innerHeight) / h * 100)));
  }
  function leave() {
    if (shownAt) { engaged += Date.now() - shownAt; shownAt = 0; }
    measureScroll();
    if (engaged > 0) {
      var o = { ms: engaged, scroll: maxScroll };
      if (lcp && !lcpSent) { o.lcp = Math.round(lcp); lcpSent = true; }
      track('page_leave', o);
      engaged = 0;
    }
    flush();
  }
  window.addEventListener('scroll', function () { measureScroll(); }, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') leave(); else if (!shownAt) { shownAt = Date.now(); ids(); }
  });
  window.addEventListener('pagehide', leave);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { maxScroll = 0; pageView(); } });
  try {
    new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { lcp = e.startTime; }); }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (e) { /* older browser */ }

  // ---------- where they click ----------
  function sectionOf(el) {
    var s = el.closest && el.closest('.shopify-section,dialog[id]');
    if (!s || !s.id) return '';
    return s.id.replace(/^shopify-section-/, '').replace(/^(template|sections)--\d+__/, '').replace(/_[A-Za-z0-9]{6}$/, '').slice(0, 40);
  }
  // A stable name, so the same button counts as one thing: no prices, and only the first line of its text.
  function labelOf(el) {
    var d = el.dataset || {};
    if (d.bpGenre) return 'Genre: ' + d.bpGenre;
    var input = el.tagName === 'INPUT' ? el : el.querySelector && el.querySelector('input[data-bp-size],input[data-bp-plan]');
    if (input && input.dataset.bpSize !== undefined) return 'Size: ' + input.value;
    if (input && input.dataset.bpPlan !== undefined) return 'Plan: ' + input.value;
    var v = d.bsTrack || d.go || d.page || el.getAttribute('aria-label');
    if (!v && el.tagName === 'INPUT') {
      var lab = el.closest('label') || (el.id && document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]'));
      v = (lab && (lab.innerText || lab.textContent)) || el.name;
    }
    if (!v) v = el.innerText || el.textContent;
    if (!v && el.tagName === 'A') v = el.getAttribute('href');
    v = String(v || el.tagName).split('\n').map(function (x) { return x.trim(); }).filter(Boolean)[0] || el.tagName;
    return v.replace(/\$[\d.,]+/g, '').replace(/\s+/g, ' ').trim().slice(0, 50);
  }
  var TEXTY = /^(text|email|tel|password|search|number|url)$/i;
  var lastClicks = [], deadCount = 0, rageAt = 0;
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest || t.closest('[data-bs-no-track]')) return;
      var section = sectionOf(t);
      var el = t.closest('a,button,summary,label,select,input,textarea,[role=button],[role=switch],[data-go],[data-page]');
      if (el && (el.tagName === 'TEXTAREA' || el.tagName === 'INPUT' && TEXTY.test(el.type))) return;
      // Tapping a label also fires a click on its input: count that one, not both.
      if (el && el.tagName === 'LABEL' && el.control && t !== el.control) return;
      var label = el ? labelOf(el) : t.tagName.toLowerCase();
      var now = Date.now();
      lastClicks = lastClicks.filter(function (c) { return now - c.t < 900; });
      lastClicks.push({ t: now, on: t });
      var same = lastClicks.filter(function (c) { return c.on === t; });
      if (same.length >= 3 && now - rageAt > 2000) { rageAt = now; track('rage_click', { label: label, section: section }); }
      if (el) track('click', { label: label, section: section });
      else if (deadCount < 5 && !String(window.getSelection ? window.getSelection() : '')) { deadCount++; track('dead_click', { label: label, section: section }); }
    } catch (err) { /* analytics never breaks the page */ }
  }, { capture: true, passive: true });

  // ---------- which sections people actually reach ----------
  function watchSections() {
    if (!window.IntersectionObserver) return;
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        var tall = x.intersectionRect.height >= window.innerHeight * 0.5;
        if (!x.isIntersecting || !(x.intersectionRatio >= 0.25 || tall)) return;
        io.unobserve(x.target);
        var name = sectionOf(x.target);
        if (name && !seen[name]) { seen[name] = 1; track('section_view', { section: name }); }
      });
    }, { threshold: [0, 0.25, 0.5] });
    document.querySelectorAll('.shopify-section').forEach(function (s) { io.observe(s); });
  }

  // ---------- box page choices (only what the visitor changed, not what the page preselected) ----------
  var touched = false, was = {}, genreTimer = null, lastGenres = '';
  // Note what's selected before the visitor's first change, so that first change counts too.
  function touch(e) {
    if (touched || !e.target || !e.target.closest || !e.target.closest('[data-bp-product]')) return;
    touched = true;
    var size = document.querySelector('[data-bp-size]:checked'), plan = document.querySelector('[data-bp-plan]:checked');
    if (was.size === undefined && size) was.size = String(size.value);
    if (was.plan === undefined && plan) was.plan = String(plan.value);
  }
  document.addEventListener('pointerdown', touch, { capture: true, passive: true });
  document.addEventListener('keydown', touch, { capture: true, passive: true });
  document.addEventListener('bp:selection-change', function (e) {
    try {
      var d = e.detail || {}, genres = (d.genres || []).slice().sort();
      if (touched) {
        if (was.size !== undefined && String(d.size) !== was.size) track('size_choice', { value: String(d.size) });
        if (was.plan !== undefined && String(d.plan) !== was.plan) track('plan_choice', { value: String(d.plan) });
        var key = genres.join('|');
        if (genres.length && key !== lastGenres) {
          clearTimeout(genreTimer);
          genreTimer = setTimeout(function () { lastGenres = key; track('genre_choice', { genres: genres }); }, 2000);
        }
      } else lastGenres = genres.join('|');
      was = { size: String(d.size), plan: String(d.plan) };
    } catch (err) { /* analytics never breaks the page */ }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-bp-gift-toggle]') && t.checked) track('gift_on');
  }, { passive: true });

  // ---------- errors visitors hit ----------
  var errors = 0;
  window.addEventListener('error', function (e) {
    if (errors >= 3 || !e.message || e.message === 'Script error.') return;
    errors++;
    var file = String(e.filename || '').split('/').pop().split('?')[0];
    track('js_error', { msg: e.message + (file ? ' (' + file + ')' : '') });
  });
  window.addEventListener('unhandledrejection', function (e) {
    if (errors >= 3) return;
    errors++;
    var r = e.reason;
    track('js_error', { msg: 'Promise: ' + String(r && r.message || r) });
  });

  // ---------- go ----------
  function start() {
    startConsent();
    pageView();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSections); else watchSections();
  }
  // A prerendered page isn't a visit until it's actually shown.
  if (document.prerendering) document.addEventListener('prerenderingchange', start, { once: true }); else start();
})();
